module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mdl-grid mdl-grid center-items"
  }, [_vm._m(0, false, false), _vm._v(" "), _vm._m(1, false, false), _vm._v(" "), _c('div', {
    staticClass: "mdl-cell mdl-cell--3-col mdl-cell--6-col-tablet",
    attrs: {
      "id": "sdt-selected-tags"
    }
  }, [_c('div', {
    staticClass: "panel-body sdt-teal-switch"
  }, [_c('label', {
    staticClass: "mdl-switch mdl-js-switch mdl-js-ripple-effect",
    attrs: {
      "for": "switch-1"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selected.editable),
      expression: "selected.editable"
    }],
    staticClass: "mdl-switch__input",
    attrs: {
      "type": "checkbox",
      "id": "switch-1"
    },
    domProps: {
      "checked": Array.isArray(_vm.selected.editable) ? _vm._i(_vm.selected.editable, null) > -1 : (_vm.selected.editable)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.selected.editable,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.selected.editable = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.selected.editable = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.selected, "editable", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "mdl-switch__label"
  }, [_vm._v("Enable drag and drop")])]), _vm._v(" "), _c('label', {
    staticClass: "mdl-switch mdl-js-switch mdl-js-ripple-effect",
    attrs: {
      "for": "switch-2"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selected.droppable),
      expression: "selected.droppable"
    }],
    staticClass: "mdl-switch__input",
    attrs: {
      "type": "checkbox",
      "id": "switch-2"
    },
    domProps: {
      "checked": Array.isArray(_vm.selected.droppable) ? _vm._i(_vm.selected.droppable, null) > -1 : (_vm.selected.droppable)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.selected.droppable,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.selected.droppable = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.selected.droppable = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.selected, "droppable", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "mdl-switch__label"
  }, [_vm._v("Enable dropping")])]), _vm._v(" "), _c('label', {
    staticClass: "mdl-switch mdl-js-switch mdl-js-ripple-effect",
    attrs: {
      "for": "switch-3"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selected.cloneable),
      expression: "selected.cloneable"
    }],
    staticClass: "mdl-switch__input",
    attrs: {
      "type": "checkbox",
      "id": "switch-3"
    },
    domProps: {
      "checked": Array.isArray(_vm.selected.cloneable) ? _vm._i(_vm.selected.cloneable, null) > -1 : (_vm.selected.cloneable)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.selected.cloneable,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.selected.cloneable = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.selected.cloneable = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.selected, "cloneable", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "mdl-switch__label"
  }, [_vm._v("\n            Enable cloning")])])]), _vm._v(" "), _c('button', {
    staticClass: "sdt-sortable-btn sdt-sort-button mdl-button mdl-button--fab mdl-button--mini-fab mdl-js-button mdl-button--raised mdl-js-ripple-effect mdl-button--accent mdl-color--teal-100",
    on: {
      "click": function($event) {
        _vm.orderList(_vm.selected.tags)
      }
    }
  }, [_c('i', {
    staticClass: "material-icons  sdt-color-teal"
  }, [_c('sort-alphabetical-icon')], 1)]), _vm._v(" "), _c('div', {
    staticClass: "mdl-cell mdl-cell--12-col mdl-card mdl-shadow--2dp mdl-color--teal-500"
  }, [_c('draggable', {
    attrs: {
      "element": "span",
      "options": _vm.getOptions(_vm.selected),
      "move": _vm.onMove
    },
    on: {
      "start": function($event) {
        _vm.isDragging = true
      },
      "end": function($event) {
        _vm.isDragging = false
      }
    },
    model: {
      value: (_vm.selected.tags),
      callback: function($$v) {
        _vm.$set(_vm.selected, "tags", $$v)
      },
      expression: "selected.tags"
    }
  }, [_c('transition-group', {
    staticClass: "mdl-list dragArea",
    attrs: {
      "type": "transition",
      "name": 'flip-list',
      "tag": "ul"
    }
  }, _vm._l((_vm.selected.tags), function(element, index) {
    return _c('li', {
      key: element.tag,
      staticClass: "sdt-tag mdl-cell mdl-cell--12-col sdt-tag-item mdl-list__item mdl-card mdl-shadow--2dp"
    }, [_c('span', {
      staticClass: "mdl-list__item-primary-content"
    }, [_c('i', {
      staticClass: "material-icons sdt-tag-icon sdt-tag-icon-left",
      class: [element.fixed ? 'sdt-color-red' : 'sdt-color-gray'],
      on: {
        "click": function($event) {
          element.fixed = !element.fixed
        }
      }
    }, [_c('lock-icon')], 1), _vm._v("\n                     " + _vm._s(element.tag) + "\n                  ")]), _vm._v(" "), _c('i', {
      staticClass: "material-icons sdt-tag-icon sdt-tag-icon-right sdt-color-teal",
      on: {
        "click": function($event) {
          _vm.onClick(index, _vm.selected, _vm.available)
        }
      }
    }, [_c('arrow-right-icon')], 1)])
  }))], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "mdl-cell mdl-cell--3-col mdl-cell--6-col-tablet",
    attrs: {
      "id": "sdt-available-tags"
    }
  }, [_c('div', {
    staticClass: "panel-body sdt-indigo-switch"
  }, [_c('label', {
    staticClass: "mdl-switch mdl-js-switch mdl-js-ripple-effect",
    attrs: {
      "for": "switch-4"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.available.editable),
      expression: "available.editable"
    }],
    staticClass: "mdl-switch__input",
    attrs: {
      "type": "checkbox",
      "id": "switch-4"
    },
    domProps: {
      "checked": Array.isArray(_vm.available.editable) ? _vm._i(_vm.available.editable, null) > -1 : (_vm.available.editable)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.available.editable,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.available.editable = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.available.editable = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.available, "editable", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "mdl-switch__label"
  }, [_vm._v("Enable drag and drop")])]), _vm._v(" "), _c('label', {
    staticClass: "mdl-switch mdl-js-switch mdl-js-ripple-effect",
    attrs: {
      "for": "switch-5"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.available.droppable),
      expression: "available.droppable"
    }],
    staticClass: "mdl-switch__input",
    attrs: {
      "type": "checkbox",
      "id": "switch-5"
    },
    domProps: {
      "checked": Array.isArray(_vm.available.droppable) ? _vm._i(_vm.available.droppable, null) > -1 : (_vm.available.droppable)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.available.droppable,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.available.droppable = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.available.droppable = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.available, "droppable", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "mdl-switch__label"
  }, [_vm._v("Enable dropping")])]), _vm._v(" "), _c('label', {
    staticClass: "mdl-switch mdl-js-switch mdl-js-ripple-effect",
    attrs: {
      "for": "switch-6"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.available.cloneable),
      expression: "available.cloneable"
    }],
    staticClass: "mdl-switch__input",
    attrs: {
      "type": "checkbox",
      "id": "switch-6"
    },
    domProps: {
      "checked": Array.isArray(_vm.available.cloneable) ? _vm._i(_vm.available.cloneable, null) > -1 : (_vm.available.cloneable)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.available.cloneable,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.available.cloneable = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.available.cloneable = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.available, "cloneable", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "mdl-switch__label"
  }, [_vm._v("Enable cloning")])])]), _vm._v(" "), _c('button', {
    staticClass: "sdt-sortable-btn sdt-sort-button mdl-button mdl-button--fab mdl-button--mini-fab mdl-js-button mdl-button--raised mdl-js-ripple-effect mdl-button--accent mdl-color--indigo-100",
    on: {
      "click": function($event) {
        _vm.orderList(_vm.available.tags)
      }
    }
  }, [_c('i', {
    staticClass: "material-icons sdt-color-indigo"
  }, [_c('sort-alphabetical-icon')], 1)]), _vm._v(" "), _c('div', {
    staticClass: "mdl-cell mdl-cell--12-col mdl-card mdl-shadow--2dp mdl-color--indigo-500"
  }, [_c('draggable', {
    attrs: {
      "element": "span",
      "options": _vm.getOptions(_vm.available),
      "move": _vm.onMove
    },
    on: {
      "start": function($event) {
        _vm.isDragging = true
      },
      "end": function($event) {
        _vm.isDragging = false
      }
    },
    model: {
      value: (_vm.available.tags),
      callback: function($$v) {
        _vm.$set(_vm.available, "tags", $$v)
      },
      expression: "available.tags"
    }
  }, [_c('transition-group', {
    staticClass: "mdl-list dragArea",
    attrs: {
      "type": "transition",
      "name": 'flip-list',
      "tag": "ul"
    }
  }, _vm._l((_vm.available.tags), function(element, index) {
    return _c('li', {
      key: element.tag,
      staticClass: "sdt-tag mdl-cell mdl-cell--12-col sdt-tag-item mdl-list__item mdl-card mdl-shadow--2dp"
    }, [_c('span', {
      staticClass: "mdl-list__item-primary-content"
    }, [_c('i', {
      staticClass: "sdt-tag-icon sdt-tag-icon-left material-icons sdt-color-indigo sdt-tag-icon",
      on: {
        "click": function($event) {
          _vm.onClick(index, _vm.available, _vm.selected)
        }
      }
    }, [_c('arrow-left-icon')], 1), _vm._v("\n                     " + _vm._s(element.tag) + "\n                  ")]), _vm._v(" "), _c('i', {
      staticClass: "material-icons sdt-tag-icon sdt-tag-icon-right",
      class: [element.fixed ? 'sdt-color-red' : 'sdt-color-gray'],
      on: {
        "click": function($event) {
          element.fixed = !element.fixed
        }
      }
    }, [_c('lock-icon')], 1)])
  }))], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "sdt-json-section mdl-cell mdl-cell--3-col mdl-cell--6-col-tablet mdl-card sdt-color-teal mdl-color--teal-50"
  }, [_c('pre', {
    staticClass: "sdt-json-pre"
  }, [_vm._v(_vm._s(_vm.selected.tags))])]), _vm._v(" "), _c('div', {
    staticClass: "sdt-json-section mdl-cell mdl-cell--3-col mdl-cell--6-col-tablet mdl-card mdl-card sdt-color-indigo mdl-color--indigo-50"
  }, [_c('pre', {
    staticClass: "sdt-json-pre"
  }, [_vm._v(_vm._s(_vm.available.tags))])]), _vm._v(" "), _vm._m(2, false, false)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "https://github.com/Josantonius/vue-draggable-tags.git"
    }
  }, [_c('img', {
    staticClass: "forkme",
    attrs: {
      "src": "https://josantonius.github.io/vue-draggable-tags/static/images/fork-me-on-github.png",
      "alt": "Fork me on GitHub"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mdl-cell mdl-cell--12-col"
  }, [_c('div', {
    staticClass: "sdt-header panel-heading"
  }, [_c('h2', {
    staticClass: "panel-title mdl-cell mdl-cell--12-col"
  }, [_vm._v("\n            DRAG, DROP & SORT TAGS\n         ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mdl-cell mdl-cell--12-col"
  }, [_c('footer', {
    staticClass: "sdt-footer"
  }, [_c('p', {
    staticClass: "panel-title mdl-cell mdl-cell--12-col"
  }, [_vm._v("Created with "), _c('a', {
    staticClass: "mdl-color-text--teal-700",
    attrs: {
      "href": "https://getmdl.io/"
    }
  }, [_vm._v("MDL")]), _vm._v(", "), _c('a', {
    staticClass: "mdl-color-text--teal-700",
    attrs: {
      "href": "https://vuejs.org/"
    }
  }, [_vm._v("Vue.js")]), _vm._v(" and "), _c('a', {
    staticClass: "mdl-color-text--teal-700",
    attrs: {
      "href": "https://github.com/SortableJS/Vue.Draggable"
    }
  }, [_vm._v("Vue.Draggable")]), _vm._v("."), _c('br'), _vm._v("© 2017 "), _c('a', {
    staticClass: "mdl-color-text--teal-700",
    attrs: {
      "href": "https://github.com/Josantonius"
    }
  }, [_vm._v("Josantonius")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-09a51b26!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/vue-draggable-tags.vue
// module id = 23
// module chunks = 1